import React from "react";
import directoryImg from "../assets/images/svg/directory_img.svg";

const Director = () => {
  return (
    <>
      <div className="bg-light-white py-xl-4">
        <div className="py-lg-3">
          <div className="container py-md-5 py-4 d-flex align-items-center justify-content-center flex-column">
            <img
              data-aos="zoom-in"
              height={64}
              width={54}
              className="w-100"
              src={directoryImg}
              alt="directoryImg"
            />
            <p
              data-aos="zoom-in"
              className="ff_lato font-sm fw-normal color-light-black opactiy_8 text-center directory_para_width mx-auto my-4 pt-lg-2"
            >
              "If we are to solve the challenges of tomorrow, we must face up to
              them today, no matter how difficult they may seem. At Cyboryx, we
              are addressing some of the most pressing technological challenges
              facing our country by bringing together a force of the brightest
              minds committed to reimagining what a secure and sustainable
              future will look like in years to come, and building it today in
              our own land - We are redefining the future now."
            </p>
            <p
              data-aos="zoom-in"
              className="ff_josfin color-light-black opactiy_8 font-lg font-medium mb-0 text-center"
            >
              Cyboryx Board of Directors
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Director;
